import {
  myFirebase,
  googleProvider,
  dbFirestore
} from '../../firebase/firebase';
import { getClientByEmail, clearClientData } from './clients';

const validateEmail = (email) => {
  var re = /^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w\-+_]+)*\s*$/;
  if (re.test(email)) {
    if (
      email.indexOf('@samxlabs.com') !== -1 ||
      email.indexOf('@adlersocial.com') !== -1 ||
      email.indexOf('@adlerlocal.com') !== -1
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const loginUser = () => {
  return async (dispatch) => {
    dispatch({ type: 'auth/loginPending' });

    const { user } = await myFirebase.auth().signInWithPopup(googleProvider);

    if (!validateEmail(user.email)) {
      dispatch({
        type: 'auth/loginError',
        payload: {
          error: 'Email not valid'
        }
      });
      return;
    }

    const userFirebase = await dbFirestore
      .collection('users')
      .doc(user.email)
      .get();
    const userData = userFirebase.data();

    if (!userData?.status) {
      dispatch({
        type: 'auth/loginError',
        payload: {
          error: 'User not found'
        }
      });
      return;
    }

    dispatch({
      type: 'auth/loginUser',
      payload: {
        user,
        role: userData?.role
      }
    });
    return;
  };
};

export const bypassLogin = () => {
  return async (dispatch) => {
    dispatch({
      type: 'auth/loginUser',
      payload: {
        user: {
          email: 'samriddha@gmail.com',
          displayName: 'Samriddha',
          uid: 'dev-user-id',
          photoURL: 'https://via.placeholder.com/150'
        },
        role: 'admin' // Assuming admin role for full access
      }
    });
  };
};

export const logoutUser = () => {
  return async (dispatch) => {
    try {
      await myFirebase.auth().signOut();
      dispatch(clearClientData());
      // Limpiar también el slice de selectedClient
      dispatch({ type: 'auth/logoutUser' });
    } catch (error) {
      dispatch({
        type: 'auth/loginError',
        payload: {
          error: 'Cannot logout'
        }
      });
      throw new Error(error);
    }
  };
};

export const validateUserAuth = (user, idToken) => ({
  type: 'auth/validateUserAuth',
  payload: {
    user,
    idToken
  }
});

// Login selector
export const authSelector = (state) => state.auth;

export const loginWithEmailPassword = (email, password) => {
  return async (dispatch) => {
    dispatch({ type: 'auth/loginPending' });

    // Limpiar estado anterior antes de hacer login
    dispatch(clearClientData());
    try {
      const { user } = await myFirebase
        .auth()
        .signInWithEmailAndPassword(email, password);

      // Check if it's an admin user (with specific domains)
      // const isAdminUser = validateEmail(user.email);

      // if (isAdminUser) {
      //   // Admin user flow - validate in Firestore
      //   const userFirebase = await dbFirestore
      //     .collection('users')
      //     .doc(user.email)
      //     .get();
      //   const userData = userFirebase.data();

      //   if (!userData?.status) {
      //     dispatch({
      //       type: 'auth/loginError',
      //       payload: {
      //         error: 'User not found'
      //       }
      //     });
      //     return;
      //   }

      //   dispatch({
      //     type: 'auth/loginUser',
      //     payload: {
      //       user,
      //       role: userData?.role
      //     }
      //   });
      // } else {
      // App user flow - fetch client data
      // Primero cargar el cliente, LUEGO autenticar
      // Esto mantiene loading=true hasta que todo termine

      // Fetch client data by email for app users
      if (user.email) {
        await dispatch(getClientByEmail(email));
      }

      dispatch({
        type: 'auth/loginUser',
        payload: {
          user,
          role: 'app-user'
        }
      });

      return;
    } catch (error) {
      let errorMessage = 'Login failed';
      if (error.code === 'auth/user-not-found') {
        errorMessage = 'User not found';
      } else if (error.code === 'auth/wrong-password') {
        errorMessage = 'Wrong password';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Invalid email';
      } else if (error.code === 'auth/user-disabled') {
        errorMessage = 'User account disabled';
      }

      dispatch({
        type: 'auth/loginError',
        payload: {
          error: errorMessage
        }
      });
    }
  };
};
